<template>
  <div>
    <div class="row">
      <div class="col-lg-12 p-5 b-blue">
        <div class="container">
          <General :user="user.profile" :contacted="user.contacted"/>
        </div>
      </div>
    </div>
    <div class="row"  v-if="user.contacted.is_contacted == true">
      <div class="col-lg-12 shadow-sm mb-3">
        <div class="b-white py-3 text-center">
          <h5 class="font-weight-light font-gray-dark">Información de CV</h5>
        </div>
      </div>
      <div class="col-lg-6 text-right py-5" id="right">
        <Education :user="user.profile"/>
        <Skill :user="user.profile"/>
        <Software :user="user.profile"/>
      </div>
      <br>
      <div class="col-lg-6 text-left py-5" id="left">
        <Experience :user="user.profile"/>
        <Project :user="user.profile"/>
        <Achievement :user="user.profile"/>
        <Service :user="user.profile"/>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
    @media only screen and (max-width: 480px) {
      #right, #left {
        text-align: center !important;
      }
    }
    @media only screen and (max-width: 544px) {
      #right, #left {
        text-align: center !important;
      }
    }
    @media only screen and (max-width: 768px) {
      #right, #left {
        text-align: center !important;
      }
    }
    @media only screen and (max-width: 960px) {
      #right, #left {
        text-align: center !important;
      }
    }

    @media only screen and (max-device-width: 480px) {
      #right, #left {
        text-align: center !important;
      }
    }
    @media only screen and (device-width: 768px) {
      #right, #left {
        text-align: center !important;
      }
    }

</style>
<script>
  import General from './elements/General'
  import Education from './elements/Education'
  import Skill from './elements/Skill'
  import Software from './elements/Software'
  import Experience from './elements/Experience'
  import Project from './elements/Project'
  import Achievement from './elements/Achievement'
  import Service from './elements/Service'

  export default {
    components: {
      'General': General,
      'Education': Education,
      'Skill': Skill,
      'Software': Software,
      'Experience': Experience,
      'Project': Project,
      'Achievement': Achievement,
      'Service': Service,
    },
    props: {
      controls: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        loading: false,
        modal: false,
        modalFilePreview: false,
        filePreview: null,
        fileDownload: null,
        motivos: [{
          text: 'Selecciona una opción',
          value: null
        }, 'Conseguí empleo en Kllaar.com', 'Conseguí empleo en otro sitio', 'Otro motivo'],
        form: {
          motivo: null
        },
        downloading: false,
        user: {}
      }
    },
    mounted() {

    },
    methods: {
      openFile(file) {
        this.fileDownload = file
        let ext = file.substr(file.lastIndexOf('.') + 1);
        if (ext == 'png' || ext == 'jpg' || ext == 'jpeg' || ext == 'gif') {
          this.filePreview = file
        } else {
          this.filePreview = null
        }

        this.modalFilePreview = true

      },
      loadProfile(id) {
        this.downloading = true
        this.api.get('candidate/profile?user_id=' + id).then(({data}) => { //Obtener toda la información de usuario y enviarla a los componentes
          this.user = data
          this.downloading = false
          this.registrarVisita();
        }).catch(err => {
        })
      },
      registrarVisita() {
        this.api.get("candidate/view-cv?student_id="+user.student_info.id).then(
          response=>{
            console.log(response)
          }
        )
      }
    },
    created() {
      let id = this.$route.query.profile
      this.loadProfile(id)
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/#pages/student_profile/StudentCV.vue